import getWidget from '../../../utils/getWidget';
import { WidgetType } from '../../types/WidgetType';

import getBattleData from './getBattleData';
import type { ModelWidgetData } from './types';

export const setupBattle = (setupModelWidgetData: ModelWidgetData): ModelWidgetData => {
  const { options, model } = setupModelWidgetData;
  const { apiFeatures, widgetFeatures, props } = options;
  const { widgetResponse } = model;

  if (!widgetResponse?.ok || !widgetResponse.data.battle) {
    return setupModelWidgetData;
  }

  const {
    widget: { data },
    models,
    battle,
  } = widgetResponse.data;

  // Setup battle if battle is enabled & a test config was returned
  const { battleFeatures, test, variant } = getBattleData(battle, props, models, data);
  apiFeatures.battleFeatures = battleFeatures;
  widgetFeatures.battleFeatures = battleFeatures;

  // Update the widget config if the widget type was changed by battle
  if (battleFeatures && battleFeatures.switchMerchantlinkToReview) {
    battleFeatures.widgetType = WidgetType.REVIEW;
  }
  if (battleFeatures && battleFeatures.widgetType) {
    const widget = getWidget(battleFeatures.widgetType as WidgetType);
    return {
      options: {
        ...options,
        apiFeatures,
        widgetFeatures,
        props: {
          ...props,
          widget,
          widgetType: widget.type,
          battle: {
            test,
            variant: {
              id: variant?.id || 0,
              name: variant?.name || '',
            },
          },
        },
      },
      model: {
        ...model,
        battleFeatures,
        widgetChanged: true,
      },
    };
  }

  return {
    options: {
      ...options,
      apiFeatures,
      widgetFeatures,
      props: {
        ...props,
        battle: {
          test,
          variant: {
            id: variant?.id || 0,
            name: variant?.name || '',
          },
        },
      },
    },
    model: {
      ...model,
      battleFeatures,
    },
  };
};
